import { render, staticRenderFns } from "./DistributionReservationList.vue?vue&type=template&id=11acf21c&scoped=true&"
import script from "./DistributionReservationList.vue?vue&type=script&lang=js&"
export * from "./DistributionReservationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11acf21c",
  null
  
)

export default component.exports